const ts = () => new Date(Date.now() + 8 * 3600000).toISOString().slice(0, 23);

export const uploadLog   = (...args: unknown[]) => console.log(`[${ts()}]`,   ...args);
export const uploadWarn  = (...args: unknown[]) => console.warn(`[${ts()}]`,  ...args);
export const uploadError = (...args: unknown[]) => console.error(`[${ts()}]`, ...args);
